import React,{Component} from 'react';
// import avatar from '../../../views/pages/images/user.jpeg';

// style
import './style.css'
const pbcTitle = {color: "#fff",width:'100%',marginTop:'120px',fontSize:'45px',textTransform:'capitalize',fontFamily: 'Montserrat', fontWeight: 100};

class PageBannerComponent extends Component{
    constructor(){
        super()
        this.state = {
            filter:''
        }
    }

       componentDidMount (){
            window.addEventListener('scroll',()=>{
                window.scrollY > 0  && this.setState({filter:'filter'});
                window.scrollY === 0  && this.setState({filter:''});
            })

        }


    render(){
        const {title, subTitle} = this.props
        const {filter} =this.state
        return (
            <div className='banner'>
                <div className={`pb-overlay ${filter}`}>
                    <div className="sb-content">
                        <div className="container">
                            <div className="row text-center">
                                <div className="col-md-12">
                                    <div className="">
                                        <h3 style={pbcTitle} className={'text-center animated fadeIn'}>
                                            {title}
                                            <br/> <span style={{color: "#229554"}}>{subTitle}</span>
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}
export default PageBannerComponent;



// WEBPACK FOOTER //
// ./src/shared/components/pageBanner/index.js